import { Component, forwardRef, ViewChild } from '@angular/core';
import { CodeInputComponent } from 'angular-code-input';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { ControlValueAccessorComponent } from '../../core';

@Component({
  selector: 'lib-pin-code-input',
  templateUrl: './pin-code-input.component.html',
  styleUrls: ['./pin-code-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PinCodeInputComponent),
      multi: true,
    },
  ],
})
export class PinCodeInputComponent
  extends ControlValueAccessorComponent
  implements ControlValueAccessor
{
  public readonly NUMBER_OF_PIN_DIGIT = 6;

  @ViewChild('codeInput') codeInput!: CodeInputComponent;

  public disabled: boolean;
  public pinForm: FormControl;

  constructor() {
    super();

    this.pinForm = new FormControl(null, [
      Validators.required,
      Validators.minLength(this.NUMBER_OF_PIN_DIGIT),
      Validators.maxLength(this.NUMBER_OF_PIN_DIGIT),
    ]);

    this.pinForm.valueChanges
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((v) => {
        if (this.pinForm.valid) {
          this._onChange(v);
        } else {
          this._onChange(null);
        }
      });
  }

  public onPinCodeChanged(code: string) {
    if (this.disabled) {
      return;
    }
    this.pinForm.setValue(code);
  }

  // required for NG_VALUE_ACCESSOR
  writeValue(pin: string) {
    if (pin !== this.pinForm.value) {
      this.pinForm.setValue(pin);
    }
  }

  // required for NG_VALUE_ACCESSOR
  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
}
